module.exports = __webpack_public_path__ + "img/guangzhou_xincheng.8169e873.png";